//scroller
document.addEventListener('DOMContentLoaded', (event) => {
    //definitions
    const scrollContainer = document.getElementById('scroll-container');
    const scrollElementWidth = document.querySelector('.scroll-element').offsetWidth;
    const minAllowableElementsInWindow = Math.max(Math.ceil(window.innerWidth / scrollElementWidth), 2);

    //initial values
    const initialDOM = scrollContainer.innerHTML;
    let elementCount = 2;
    let reqAnim;

    //setup
    let SCROLL_SPEED = 0.5;
    
    let scrollPosition = 0;

    //methods
    const addNewElement = element => scrollContainer.innerHTML += element;
    const evaluableCountOfElements = () => {
        if (window.innerWidth <= scrollElementWidth * minAllowableElementsInWindow) {
            for (let i = 1; i <= minAllowableElementsInWindow; i++) {
                addNewElement(initialDOM);
                elementCount++
            }
        }
    };
    const scrollBegin = () => {
        scrollPosition += SCROLL_SPEED;
        scrollContainer.style.transform = `translateX(-${scrollPosition}px)`;
        if (scrollPosition >= scrollContainer.scrollWidth / elementCount) {
            scrollPosition = 0;
        }
        reqAnim = window.requestAnimationFrame(scrollBegin);
    };
    const stopAnimation = () => cancelAnimationFrame(reqAnim);

    //implementation
    addNewElement(initialDOM);
    evaluableCountOfElements();
    scrollBegin();

    //features
    scrollContainer.addEventListener('mouseenter', () => stopAnimation());
    scrollContainer.addEventListener('mouseleave', () => scrollBegin());
});
// You can check it out here https://playcode.io/1881591